import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { abortController } from 'store/utils';
import measurementsStore from 'store/measurements';
import { attachFilesApi, deleteFileLinkApi, getConfigApi, getSupportLanguagesApi, updateFileApi, uploadFileApi, addToFavoriteApi, deleteFromFavoriteApi, getFavoritesApi, } from './api';
import { applyCurrentCountryMeasurements } from './countryUtils';
const uploadFiles = async ({ files }) => {
    try {
        const res = await Promise.all(files?.map(async (file) => {
            const formData = new FormData();
            formData.append('file', file);
            const { data } = await uploadFileApi(formData);
            return data;
        }));
        return res;
    }
    catch (error) {
        // @ts-ignore
        throw error.response.data;
    }
};
const initialState = {
    availableLanguages: [],
    isStatisticsMode: true,
    appIsUpdated: false,
    config: {
        unitTypes: undefined,
        unitLayouts: undefined,
        amenities: undefined,
        finishes: undefined,
        socialNetworks: undefined,
    },
};
const actions = {
    toggleIsStatisticsMode: (_, { setState }) => {
        setState((state) => {
            state.isStatisticsMode = !state.isStatisticsMode;
        });
    },
    setAppIsUpdated: (payload, { setState }) => {
        setState((state) => {
            state.appIsUpdated = payload;
        });
    },
    getConfig: async (isMobile, { setState }) => {
        try {
            const { data } = await getConfigApi();
            const measurementsState = measurementsStore.getState();
            applyCurrentCountryMeasurements(data.currentCountry, isMobile ? measurementsState : undefined);
            setState((state) => {
                state.config = {
                    ...state.config,
                    ...data,
                    unitTypesMap: data.unitTypes.reduce((acc, item) => ({ ...acc, [Number(item.id)]: item }), {}),
                    unitLayoutsMap: data.unitLayouts.reduce((acc, item) => ({ ...acc, [Number(item.id)]: item }), {}),
                };
            });
            return data;
        }
        catch (error) {
            // @ts-ignore
            throw error.response.data;
        }
    },
    uploadFile: async ({ additionalInfo, file }) => {
        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('additionalInfo', JSON.stringify(additionalInfo));
            const { data } = await uploadFileApi(formData);
            return data;
        }
        catch (error) {
            // @ts-ignore
            throw error.response.data.message;
        }
    },
    uploadFiles,
    attachFiles: async (items) => {
        try {
            const data = await attachFilesApi(items);
            return data;
        }
        catch (error) {
            // @ts-ignore
            throw error.response.data;
        }
    },
    uploadAndAttachFiles: async ({ items, modelId, modelType, scope, }) => {
        try {
            const data = await uploadFiles({ files: items.map(({ file }) => file) })
                .then((res) => res.map((item, i) => ({
                ...item,
                ...items[i],
                file: undefined,
                modelId,
                modelType,
                scope,
                id: item.fileId,
            })))
                .then(async (res) => {
                await attachFilesApi(res);
                return res;
            });
            return data;
        }
        catch (error) {
            // @ts-ignore
            throw error.message;
        }
    },
    updateFiles: async ({ items }) => {
        try {
            const data = await Promise.all(items.map((item) => updateFileApi(item)));
            return data.map((item) => item.data);
        }
        catch (error) {
            // @ts-ignore
            throw error.response.data;
        }
    },
    deleteFileLink: async ({ ids }) => {
        try {
            // @ts-ignore Не помню почему тут { data }, но вероятно это нужно
            const { data } = await Promise.all(ids.map((id) => deleteFileLinkApi({ pivotId: id })));
            return data;
        }
        catch (error) {
            // @ts-ignore
            throw error.response.data;
        }
    },
    getAvailableLanguages: async (_, { setState }) => {
        try {
            const { data: { data: languages } } = await getSupportLanguagesApi();
            setState((state) => ({ ...state, availableLanguages: languages }));
            return languages;
        }
        catch (error) {
            //  @ts-ignore
            throw error.message;
        }
    },
    getFavorites: async (modelType) => {
        try {
            const { data } = await getFavoritesApi(modelType);
            return data;
        }
        catch (err) {
            const error = err;
            throw error.response?.data.message;
        }
    },
    addToFavorite: async ({ modelType, id }) => {
        try {
            const { data } = await addToFavoriteApi(modelType, id);
            return data;
        }
        catch (err) {
            const error = err;
            throw error.response?.data.message;
        }
    },
    deleteFromFavorite: async ({ modelType, id }) => {
        try {
            const { data } = await deleteFromFavoriteApi(modelType, id);
            return data;
        }
        catch (err) {
            const error = err;
            throw error.response?.data.message;
        }
    },
};
const store = { ...initialState, ...actions };
export default create()(devtools(immer((set, get) => abortController(store, set, get, 'Common')), {
    name: 'Common',
}));
